<template>
    <div class="form">
        <ValidationObserver ref="form">
            <h2 class="profile__title">Additional Information</h2>
            <div class="row">
                <ValidationProvider
                    class="col-12"
                    name="Requirements"
                    v-slot="{ errors }"
                    rules="min:3|max:2000"
                >
                    <div class="form-group">
                        <label for="" class="form-label">Requirements for Artist/Show</label>
                        <textarea
                            class="form-control pl-4"
                            placeholder="Type tour text here"
                            v-model="client.additional_info"
                        ></textarea>
                        <FormError :error="errors[0]" name="Requirements"/>
                    </div>
                </ValidationProvider>
            </div>
            <BaseButtons
                v-if="isPermission"
                :on-cancel="reloadPage"
                :on-save="validateForm"
            />

        </ValidationObserver>
    </div>

</template>

<script>
import BaseButtons from "../Common/BaseButtons.vue";
import ModalHandler from "../../mixins/ModalHandler";
import {mapState} from "pinia";
import {useClientStore} from "../../stores/ClientStore";
import FormError from "../Common/FormError.vue";
import ClientService from "../../services/ClientService";

export default {
    name: 'ClientAdditionalInformation',
    components: {FormError, BaseButtons},
    mixins: [ModalHandler],
    props: {
        adminType: String
    },
    computed: {
        ...mapState(useClientStore, {
            client: 'client',
            clientId: 'clientId'
        }),
        isPermission() {
            return this.adminType !== 'agent'
        },
    },
    methods: {
        async validateForm() {
            const valid = await this.$refs.form.validate();
            if (!valid) {
                this.$showValidationErrorMessage();
            } else {
                await this.updateClientRequirements();
            }
        },
        async updateClientRequirements() {
            try {
                await ClientService.updateAdditionalInformation(this.clientId, this.client.additional_info);
                this.$showSuccessMessage('Profile was successfully updated');
            } catch (error) {
                this.$showErrorMessage('The profile has not been updated');
            }
        },

    }
}

</script>


<style scoped>

</style>
